import {
  buildLoadDataCachedFn,
  fetchDataOnOrganizationChange,
  fetchDataOnProjectChange,
} from '../../redux/actions/router/utils/utils';
import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';
import { teamMembersService } from '../../transport/services/team-members-service';

import { TeamMemberRoles } from './team.constants';
import { TeamMember } from './team.types';
import { getSelectedProjectId } from '../../redux/projects/projects.selectors';

export const TEAM_MEMBERS_ACTION_NAMES = {
  GET_TEAM_MEMBERS_START: 'TEAM_MEMBERS_ACTION_NAMES__GET_TEAM_MEMBERS_START',
  GET_TEAM_MEMBERS_SUCCESS:
    'TEAM_MEMBERS_ACTION_NAMES__GET_TEAM_MEMBERS_SUCCESS',
  GET_TEAM_MEMBERS_ERROR: 'TEAM_MEMBERS_ACTION_NAMES__GET_TEAM_MEMBERS_ERROR',

  GET_TEAM_MEMBERS_FOR_PROJECT_START:
    'TEAM_MEMBERS_ACTION_NAMES__GET_TEAM_MEMBERS_FOR_PROJECT_START',
  GET_TEAM_MEMBERS_FOR_PROJECT_SUCCESS:
    'TEAM_MEMBERS_ACTION_NAMES__GET_TEAM_MEMBERS_FOR_PROJECT_SUCCESS',
  GET_TEAM_MEMBERS_FOR_PROJECT_ERROR:
    'TEAM_MEMBERS_ACTION_NAMES__GET_TEAM_MEMBERS_FOR_PROJECT_ERROR',

  GET_INVITATIONS_MEMBERS_START:
    'TEAM_MEMBERS_ACTION_NAMES__GET_INVITATIONS_MEMBERS_START',
  GET_INVITATIONS_MEMBERS_SUCCESS:
    'TEAM_MEMBERS_ACTION_NAMES__GET_INVITATIONS_MEMBERS_SUCCESS',
  GET_INVITATIONS_MEMBERS_ERROR:
    'TEAM_MEMBERS_ACTION_NAMES__GET_INVITATIONS_MEMBERS_ERROR',

  GET_INVITATIONS_MEMBERS_FOR_PROJECT_START:
    'TEAM_MEMBERS_ACTION_NAMES__GET_INVITATIONS_MEMBERS_FOR_PROJECT_START',
  GET_INVITATIONS_MEMBERS_FOR_PROJECT_SUCCESS:
    'TEAM_MEMBERS_ACTION_NAMES__GET_INVITATIONS_MEMBERS_FOR_PROJECT_SUCCESS',
  GET_INVITATIONS_MEMBERS_FOR_PROJECT_ERROR:
    'TEAM_MEMBERS_ACTION_NAMES__GET_INVITATIONS_MEMBERS_FOR_PROJECT_ERROR',

  OPEN_ADD_MEMBER_MODAL: 'TEAM_MEMBERS_ACTION_NAMES__OPEN_ADD_MEMBER_MODAL',
  CLOSE_ADD_MEMBER_MODAL: 'TEAM_MEMBERS_ACTION_NAMES__CLOSE_ADD_MEMBER_MODAL',

  OPEN_DELETE_MEMBER_MODAL:
    'TEAM_MEMBERS_ACTION_NAMES__OPEN_DELETE_MEMBER_MODAL',
  CLOSE_DELETE_MEMBER_MODAL:
    'TEAM_MEMBERS_ACTION_NAMES__CLOSE_DELETE_MEMBER_MODAL',

  OPEN_MEMBER_DELETE_MODAL_FROM_EDIT_MODAL:
    'TEAM_MEMBERS_ACTION_NAMES__OPEN_MEMBER_DELETE_MODAL_FROM_EDIT_MODAL',

  OPEN_MEMBER_EDIT_MODAL: 'TEAM_MEMBERS_ACTION_NAMES__OPEN_MEMBER_EDIT_MODAL',
  CLOSE_MEMBER_EDIT_MODAL: 'TEAM_MEMBERS_ACTION_NAMES__CLOSE_MEMBER_EDIT_MODAL',

  FILTER_TEAM_MEMBERS_BY_ROLE:
    'TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_ROLE',
  FILTER_TEAM_MEMBERS_BY_PROJECT:
    'TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_PROJECT',
  FILTER_TEAM_MEMBERS_BY_SEARCH:
    'TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_SEARCH',
};

const loadTeamMembersData = (context, dispatch, getState) => {
  const state = getState();
  const organizationId = getSelectedOrganizationId(state, { router: context });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return dispatch({
    types: [
      TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_START,
      TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_SUCCESS,
      TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_ERROR,
    ],
    callApi: () => teamMembersService.getTeamMembers({ organizationId }),
  });
};

const teamMembersLoadDataCached = buildLoadDataCachedFn(
  loadTeamMembersData,
  fetchDataOnOrganizationChange,
);

export const getTeamMembersCached = (context) => (dispatch, getState) => {
  return teamMembersLoadDataCached(context, dispatch, getState);
};

const loadTeamMembersDataForProject = (context, dispatch, getState) => {
  const state = getState();
  const organizationId = getSelectedOrganizationId(state, { router: context });
  const projectId = getSelectedProjectId(state, { router: context });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return dispatch({
    types: [
      TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_FOR_PROJECT_START,
      TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_FOR_PROJECT_SUCCESS,
      TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_FOR_PROJECT_ERROR,
    ],
    callApi: () =>
      teamMembersService.getTeamMembersForProject({
        organizationId,
        projectId,
      }),
  });
};

const teamMembersForProjectLoadDataCached = buildLoadDataCachedFn(
  loadTeamMembersDataForProject,
  fetchDataOnProjectChange,
);

export const getTeamMembersForProjectCached =
  (context) => (dispatch, getState) => {
    return teamMembersForProjectLoadDataCached(context, dispatch, getState);
  };

export const getTeamMembers = (context) => (dispatch, getState) => {
  return loadTeamMembersData(context, dispatch, getState);
};

const loadInvitationsData = (context, dispatch, getState) => {
  const state = getState();
  const organizationId = getSelectedOrganizationId(state, { router: context });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return dispatch({
    types: [
      TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_START,
      TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_SUCCESS,
      TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_ERROR,
    ],
    callApi: () => teamMembersService.getInvitations({ organizationId }),
  });
};

const invitationsLoadDataCached = buildLoadDataCachedFn(
  loadInvitationsData,
  fetchDataOnOrganizationChange,
);

export const getInvitationsCached = (context) => (dispatch, getState) => {
  return invitationsLoadDataCached(context, dispatch, getState);
};

export const getInvitationsForProjectCached =
  (context) => (dispatch, getState) => {
    return invitationsForProjectLoadDataCached(context, dispatch, getState);
  };

const loadInvitationsDataForProject = (context, dispatch, getState) => {
  const state = getState();
  const organizationId = getSelectedOrganizationId(state, { router: context });
  const projectId = getSelectedProjectId(state, { router: context });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return dispatch({
    types: [
      TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_START,
      TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_SUCCESS,
      TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_ERROR,
    ],
    callApi: () =>
      teamMembersService.getInvitations({ organizationId, projectId }),
  });
};

const invitationsForProjectLoadDataCached = buildLoadDataCachedFn(
  loadInvitationsDataForProject,
  fetchDataOnProjectChange,
);

export const openTeamMemberAddModal = () => ({
  type: TEAM_MEMBERS_ACTION_NAMES.OPEN_ADD_MEMBER_MODAL,
  payload: undefined,
});

export const closeTeamMemberAddModal = () => ({
  type: TEAM_MEMBERS_ACTION_NAMES.CLOSE_ADD_MEMBER_MODAL,
  payload: undefined,
});

export const filterTeamMembersByProjectId = (projectId: string) => ({
  type: TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_PROJECT,
  payload: projectId,
});

export const openTeamMemberDeleteModal = (member: TeamMember) => ({
  type: TEAM_MEMBERS_ACTION_NAMES.OPEN_DELETE_MEMBER_MODAL,
  payload: member,
});

export const closeTeamMemberDeleteModal = () => ({
  type: TEAM_MEMBERS_ACTION_NAMES.CLOSE_DELETE_MEMBER_MODAL,
  payload: undefined,
});

export const openTeamMemberDeleteModalFromEditModal = () => ({
  type: TEAM_MEMBERS_ACTION_NAMES.OPEN_MEMBER_DELETE_MODAL_FROM_EDIT_MODAL,
  payload: undefined,
});

export const openTeamMemberEditModal = (member: TeamMember) => ({
  type: TEAM_MEMBERS_ACTION_NAMES.OPEN_MEMBER_EDIT_MODAL,
  payload: member,
});

export const closeTeamMemberEditModal = () => ({
  type: TEAM_MEMBERS_ACTION_NAMES.CLOSE_MEMBER_EDIT_MODAL,
  payload: undefined,
});

export const filterTeamMembersByRole = (role: TeamMemberRoles) => ({
  type: TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_ROLE,
  payload: role,
});

export const filterTeamMembersBySearch = (value: string) => ({
  type: TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_SEARCH,
  payload: value,
});
